export default "/images/0973e0663f46c2d307da48be3308fe1c.avif";